<template>
  <div>
    <!-- <button style="position: absolute; right: 0; top: -85px; z-index: 1001; color: #fff;" class="btn btn-primary w-min-sm waves-effect waves-light ml-1 my-1 btn-save-hover">
      Save
    </button> -->
    <div class="">
      <div style="margin-top: -15px"  class="billing">
        <div class="">
          <div class="tabs-component tabs-component-2" style="padding-top: 0px; margin-bottom: 15px">
            <div class="tabs-component-w">
              <ul class="nav nav-tabs nav-tabs-2  float-sm-left">
                <li style='padding-top: 0px' @click="selectedTab('settings')" class="tabs-component-tab nav-item">
                  <span href="" class="tabs-component-tab-a nav-link" :class="{'active': currentTab === 'settings'}">Settings</span>
                </li>
                <li @click="selectedTab('invoices')" class="tabs-component-tab nav-item">
                  <span href="" class="tabs-component-tab-a nav-link" :class="{'active': currentTab === 'invoices'}">Invoices</span>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="currentTab === 'settings'">
            <div class="col-lg-4 col-12 settings-tab-width">
              <div class="card-header bg-navyblue">
                <strong>Plan</strong>
              </div>
              <div class="card-block bg-white">

                <div class="form-group row no-gutter rs-toggle">
                  <label class="col-sm-3 col-form-label  left-col"
                         for="status">
                    Status
                  </label>
                  <div class="col-sm-9 right-col  col-with-active-btn">
                    <div class="d-flex">
                      <toggle-button
                          :disabled="true"
                          v-model="vendorInfo.isActive"
                          id="status"
                          class="mb-0 rs-toggle__button"
                          color="#5E79FF"
                          style="opacity: 1"
                          :sync="true"
                          :width="40"
                          :labels="false"/>
                      <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                                <template v-if="isStatusActive">Active</template>
                                <template  v-else>Not Active</template>
                            </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter">
                  <label style="margin-top: 22px" class="col-sm-3 col-form-label left-col"
                         for="plan">
                    Plan Type
                 </label>
                  <div class="col-sm-9 right-col col-with-active-btn">
                    <multiselect v-model="computedPlanType"
                                 :options="planTypeOptions"
                                 :showLabels="false"
                                 label="name"
                                 @select="onSelectPlanType"
                                 track-by="id"
                                 placeholder="Select Plan Type"
                                 :disabled="!isStatusActive"
                                 :close-on-select="true"
                                 style="z-index: 4; opacity: 1; width: 162px;">
                    </multiselect>
                  </div>
                </div>
                <div class="form-group row no-gutter">
                  <label style="margin-top: 2px" class="col-sm-3 col-form-label  left-col"
                         for="cost">
                    Cost (Per/Month)
                  </label>
                  <div class="col-sm-9 right-col">
                    <number-formatter ref="rr"
                                      v-model="computedCost"
                                      id="cost"
                                      type="text"
                                      class="form-control w-162"
                                      placeholder=""
                                      format="$00,0.00"
                                      :isDisabled="true"
                    ></number-formatter>
                  </div>
                </div>
                <div class="form-group row no-gutter">
                  <label style="margin-top: 2px" class="col-sm-3 col-form-label  left-col"
                         for="limit">
                    Data Storage Limit
                  </label>
                  <div class="col-sm-9 right-col">
                    <input
                        v-model="computedLimit"
                        id="limit"
                        type="text"
                        readonly
                        class="form-control w-162">
                  </div>
                </div>
                <div class="form-group row no-gutter">
                  <label class="col-sm-3 col-form-label left-col"
                         for="data_storage_consumed">
                    <p>Data Storage Consumed</p>
                    <p class="description-text">Includes Images and Files that
                      <br>
                      are stored as part of your
                      <br>
                      account.
                    </p>
                  </label>
                  <div class="col-sm-9 right-col">
                    <b-progress height="32px" class="progress-of-gb">
                      <span class="progress-text" :class="[{'progress-text-black': (!isOverLimit && computedProgressTextAlign != 'progress-text-left')}, {'progress-text-white':isOverLimit}, computedProgressTextAlign]">{{this.value?.billing?.info.storage.consumed}} GB</span>
                      <b-progress-bar :class="[ computedColorForProgressBar ]" class="progress-bar-of-gb"  :max="this.value?.billing?.info.storage.limit" variant="success" :value="computedStorageConsumedLimit">

                      </b-progress-bar>
                    </b-progress>
                    <p v-if="isOverLimit" style="font-size: 12px">Your account Data storage limit has been reached. Increase it by adding a Data Add-on pack.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-12 settings-tab-width">
              <div class="card-header bg-navyblue">
                <strong>Add-Ons</strong>
              </div>
              <div class="card-block bg-white" style="padding-right: 0px">

                <div class="form-group row no-gutter rs-toggle">
                  <label class="col-sm-3 col-form-label description"
                         for="rego">
                    <p>REGO/VIN LOOKUP</p>
                    <p class="description-text">Charged at $0.48 per lookup (Ex GST).
                      <br>
                      Billed Monthly</p>

                  </label>
                  <div class="col-sm-9 col-with-active-btn">
                    <div class="d-flex">
                      <toggle-button
                          v-model="value.billing?.settings.reg_vin_lookup"
                          id="rego"
                          class="mb-0 rs-toggle__button"
                          color="#5E79FF"
                          :sync="true"
                          :width="40"
                          :disabled="value.billing?.settings.reg_vin_lookup_with_build_and_compliance || !isStatusActive"
                          :labels="false"/>
                      <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                  <template v-if="value.billing?.settings.reg_vin_lookup">Active</template>
                  <template v-else>Not Active</template>
                </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter rs-toggle">
                  <label class="col-sm-3 col-form-label description"
                         for="build_and_compliance">
                    <p>REGO/VIN LOOKUP W/Build & Compliance</p>
                    <p class="description-text">Charged at $0.60 per lookup (Ex GST).
                      <br>
                      Billed Monthly</p>

                  </label>
                  <div class="col-sm-9 col-with-active-btn">
                    <div class="d-flex">
                      <toggle-button
                          v-model="value.billing?.settings.reg_vin_lookup_with_build_and_compliance"
                          id="build_and_compliance"
                          class="mb-0 rs-toggle__button"
                          color="#5E79FF"
                          :sync="true"
                          :width="40"
                          :disabled="value.billing?.settings.reg_vin_lookup || !isStatusActive"
                          :labels="false"/>
                      <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                  <template v-if="value.billing?.settings.reg_vin_lookup_with_build_and_compliance">Active</template>
                  <template v-else>Not Active</template>
                </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter rs-toggle">
                  <label class="col-sm-3 col-form-label description"
                         for="rego_always_on">
                    <p>REGO/VIN LOOKUP - Always On</p>
                    <p class="description-text">Enables always on for every New File
                      <br>
                      or Rego field search. No extra Charge</p>
                  </label>
                  <div class="col-sm-9 col-with-active-btn">
                    <div class="d-flex">
                      <toggle-button
                          v-model="value.billing?.settings.reg_vin_lookup_always_on"
                          @change="changedLookupStatus"
                          id="rego_always_on"
                          class="mb-0 rs-toggle__button"
                          color="#5E79FF"
                          :disabled="!isStatusActive"
                          :sync="true"
                          :width="40"
                          :labels="false"/>
                      <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                  <template v-if="value.billing?.settings.reg_vin_lookup_always_on">Active</template>
                  <template v-else>Not Active</template>
                </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter rs-toggle">
                  <label class="col-sm-3 col-form-label description"
                         for="sms">
                    <p>SMS Messaging - Outgoing</p>
                    <p class="description-text">Charged at $0.10 per SMS (Ex GST)
                      <br>
                      Billed Monthly</p>
                  </label>
                  <div class="col-sm-9 col-with-active-btn">
                    <div class="d-flex">
                      <toggle-button
                          v-model="value.billing?.settings.sms_messaging"
                          id="sms"
                          class="mb-0 rs-toggle__button"
                          color="#5E79FF"
                          :sync="true"
                          :disabled="!isStatusActive"
                          :width="40"
                          :labels="false"/>
                      <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                  <template v-if="value.billing?.settings.sms_messaging">Active</template>
                  <template v-else>Not Active</template>
                </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter rs-toggle">
                  <label class="col-sm-3 col-form-label description"
                         for="sms">
                    <p>SMS Messaging - Incoming</p>
                    <p class="description-text">Charged at $0.02 per SMS (Ex GST)
                      <br>
                      Billed Monthly</p>
                  </label>
                  <div class="col-sm-9 col-with-active-btn">
                    <div class="d-flex">
                      <toggle-button
                          v-model="value.billing?.settings.sms_messaging_incoming"
                          id="sms"
                          class="mb-0 rs-toggle__button"
                          color="#5E79FF"
                          :sync="true"
                          :disabled="!isStatusActive"
                          :width="40"
                          :labels="false"/>
                      <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                  <template v-if="value.billing?.settings.sms_messaging_incoming">Active</template>
                  <template v-else>Not Active</template>
                </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter">
                  <label class="col-sm-3 col-form-label description"
                         for="add_on">
                    <p>Data Storage Add-on</p>
                    <p class="description-text">
                      Charged at {{ this.currentStorageAddonInfo.price | formatMoney }} per {{ this.currentStorageAddonInfo.per }}
                      <br>
                      (Ex GST). Billed {{ this.currentStorageAddonInfo.billed }}
                    </p>
                  </label>
                  <div class="col-sm-9 col-with-active-btn">
                    <multiselect v-model="computedPlan"
                                 :options="storageAddonOptions"
                                 :showLabels="false"
                                 label="name"
                                 @select="onSelectPlan"
                                 :option-height="31.5"
                                 placeholder="Select GB"
                                 :disabled="!isStatusActive"
                                 :close-on-select="true"
                                 style="z-index: 4; opacity: 1;">
                    </multiselect>
                  </div>
                </div>
                <div class="form-group row no-gutter rs-toggle">
                  <label class="col-sm-3 col-form-label description"
                         for="add_on_status">
                    <p>Data Storage Add-on - As Needed</p>
                    <p class="description-text">Automatically adds additional <br/> storage on demand once you limit <br/> is reached.</p>
                  </label>
                  <div class="col-sm-9 col-with-active-btn">
                    <div class="d-flex">
                      <toggle-button
                          v-model="value.billing?.settings.storage_addon_as_needed"
                          id="add_on_status"
                          class="mb-0 rs-toggle__button"
                          color="#5E79FF"
                          :disabled="!isStatusActive"
                          :sync="true"
                          :width="40"
                          :labels="false"/>
                      <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                  <template v-if="value.billing?.settings.storage_addon_as_needed">Active</template>
                  <template v-else>Not Active</template>
                </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutter rs-toggle">
                  <label class="col-sm-3 col-form-label description"
                         for="add_on_status">
                    <p>Close your Repair-shop account.</p>
                    <p class="description-text" style="max-width: 200px">All accounts users and services will no longer be accessible.</p>
                  </label>
                  <div class="col-sm-9 col-with-active-btn">
                    <button @click="clickCloseAccount()" style="background-color: #5E79FF; color: white; width: 130px" class="btn btn-primary waves-effect waves-light">Close Account</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-12 settings-tab-width-credits" v-if="!isAiCopilotFullyInActive && hasBillingCredits">
              <div class="card-header bg-navyblue">
                <strong>RS AI - Credits</strong>
              </div>
              <div class="card-block bg-white" style="padding-right: 0px">

                <div class="row no-gutter rs-toggle d-flex" v-if="!isAiCopilotDamageDisabled">
                  <div class="col-form-label col-sm-11" style="font-size: 14px">Assissted Estimates</div>
                  <div class="col-sm-1"><img src="../../assets/img/ai-icon-new.png" height="30" width="30"/></div>
                </div>

              </div>
              <div class="billing-settings-rs-table" v-if="!isAiCopilotDamageDisabled">
                <div class="billing-settings-rs-table-header">
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-name">Service Name</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-remaining">Remaining Credit Qty</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-cost">Cost</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-auto">Auto TopUp</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-btn"></div>
                </div>
                <div class="d-flex billing-settings-rs-table-body">
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-name">Quick Estimate - Dollars Standard</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-remaining">{{aiCredits.daDollarsStandard}}</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-cost">$5.00</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-auto">
                    <div v-if="hasSavedCards"
                         class="col-with-active-btn">
                      <div class="d-flex" >
                        <toggle-button
                            v-model="billingAutoTopUp.daDollarsStandard"
                            id="rego"
                            class="mb-0 rs-toggle__button"
                            color="#5E79FF"
                            :disabled="!hasSavedCards"
                            :sync="true"
                            :width="30"
                            :labels="false"/>
                        <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25" style="font-size: 10px">
                            <template v-if="billingAutoTopUp.daDollarsStandard">Active</template>
                            <template v-else>Not Active</template>
                          </span>
                      </div>
                    </div>
                    <div v-else v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'To enable Auto top-up, saved your card next time you Purchase more credit', placement:'bottom'}"
                         class="col-with-active-btn">
                      <div class="d-flex" >
                        <toggle-button
                            v-model="billingAutoTopUp.daDollarsStandard"
                            id="rego"
                            class="mb-0 rs-toggle__button"
                            color="#5E79FF"
                            :disabled="!hasSavedCards"
                            :sync="true"
                            :width="30"
                            :labels="false"/>
                        <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25" style="font-size: 10px">
                            <template v-if="billingAutoTopUp.daDollarsStandard">Active</template>
                            <template v-else>Not Active</template>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-btn">
                    <button  v-if="this.isShopManagerUser || this.isProductionManagerUser" @click="$refs.modalAddCredits.show()" class="btn btn-primary" style="background-color: rgb(94, 121, 255); color: white; width: 90px">Buy More</button>
                  </div>
                </div>
                <div class="d-flex billing-settings-rs-table-body">
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-name">NTAR/LTAR - Standard</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-remaining">{{ aiCredits.daNtarltarStandard }}</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-cost">$5.00</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-auto">
                    <div v-if="hasSavedCards"
                         class="col-with-active-btn">
                      <div class="d-flex" >
                        <toggle-button
                            v-model="billingAutoTopUp.daNtarltarStandard"
                            id="rego"
                            class="mb-0 rs-toggle__button"
                            color="#5E79FF"
                            :disabled="!hasSavedCards"
                            :sync="true"
                            :width="30"
                            :labels="false"/>
                        <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25" style="font-size: 10px">
                            <template v-if="billingAutoTopUp.daNtarltarStandard">Active</template>
                            <template v-else>Not Active</template>
                        </span>
                      </div>
                    </div>
                    <div v-else v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'To enable Auto top-up, saved your card next time you Purchase more credit', placement:'bottom'}"
                         class="col-with-active-btn">
                      <div class="d-flex" >
                        <toggle-button
                            v-model="billingAutoTopUp.daNtarltarStandard"
                            id="rego"
                            class="mb-0 rs-toggle__button"
                            color="#5E79FF"
                            :disabled="!hasSavedCards"
                            :sync="true"
                            :width="30"
                            :labels="false"/>
                        <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25" style="font-size: 10px">
                            <template v-if="billingAutoTopUp.daNtarltarStandard">Active</template>
                            <template v-else>Not Active</template>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-btn">
                    <button @click="$refs.modalAddCredits.show()" class="btn btn-primary" style="background-color: rgb(94, 121, 255); color: white; width: 90px">Buy More</button>
                  </div>
                </div>
              </div>

              <div class="card-block bg-white" style="padding-right: 0px" v-if="!isAiCopilotVehicleDisabled">

                <div class="row no-gutter rs-toggle d-flex">
                  <div class="col-form-label col-sm-11" style="font-size: 14px">Vehicle Identifier</div>
                  <div class="col-sm-1"><img src="../../assets/img/ai-icon-new.png" height="30" width="30"/></div>
                </div>

              </div>
              <div class="billing-settings-rs-table" v-if="!isAiCopilotVehicleDisabled">
                <div class="billing-settings-rs-table-header">
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-name">Service Name</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-remaining">Remaining Credit Qty</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-cost">Cost</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-auto">Auto TopUp</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-btn"></div>
                </div>
                <div class="d-flex billing-settings-rs-table-body" :class="{'billing-disabled': isPremiumPlan}">
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-name">Vehicle Identifier</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-remaining">{{ !isPremiumPlan ? aiCredits.viVehicleIdentification : '*'  }}</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-cost">$0.30</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-auto">
                    <div v-if="hasSavedCards"
                         class="col-with-active-btn">
                      <div class="d-flex" @click="onAutoTopUpToggleClick">
                        <toggle-button
                            v-model="billingAutoTopUp.viVehicleIdentification"
                            id="rego"
                            class="mb-0 rs-toggle__button"
                            color="#5E79FF"
                            :disabled="!hasSavedCards || isPremiumPlan"
                            :sync="true"
                            :width="30"
                            :labels="false"/>
                        <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25" style="font-size: 10px">
                            <template v-if="billingAutoTopUp.viVehicleIdentification">Active</template>
                            <template v-else>Not Active</template>
                          </span>
                      </div>
                    </div>
                    <div v-else v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'To enable Auto top-up, saved your card next time you Purchase more credit', placement:'bottom'}"
                         class="col-with-active-btn">
                      <div class="d-flex" @click="onAutoTopUpToggleClick">
                        <toggle-button
                            v-model="billingAutoTopUp.viVehicleIdentification"
                            id="rego"
                            class="mb-0 rs-toggle__button"
                            color="#5E79FF"
                            :disabled="!hasSavedCards || isPremiumPlan"
                            :sync="true"
                            :width="30"
                            :labels="false"/>
                        <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25" style="font-size: 10px">
                            <template v-if="billingAutoTopUp.viVehicleIdentification">Active</template>
                            <template v-else>Not Active</template>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-btn">
                    <button @click="$refs.modalAddCredits.show()" class="btn btn-primary" style="background-color: rgb(94, 121, 255); color: white; width: 90px" :disabled="isPremiumPlan">Buy More</button>
                  </div>
                </div>
              </div>

              <div class="card-block bg-white" style="padding-right: 0px" v-if="!isAiCopilotPartsInfoDisabled" >

                <div class="row no-gutter rs-toggle d-flex">
                  <div class="col-form-label col-sm-11" style="font-size: 14px">Parts Identifier</div>
                  <div class="col-sm-1"><img src="../../assets/img/ai-icon-new.png" height="30" width="30"/></div>
                </div>

              </div>
              <div class="billing-settings-rs-table" v-if="!isAiCopilotPartsInfoDisabled">
                <div class="billing-settings-rs-table-header">
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-name">Service Name</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-remaining">Remaining Credit Qty</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-cost">Cost</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-auto">Auto TopUp</div>
                  <div class="billing-settings-rs-table-header-item billing-settings-rs-table-header-btn"></div>
                </div>
                <div class="d-flex billing-settings-rs-table-body" :class="{'billing-disabled': isPremiumPlan}">
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-name">Parts Identifier</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-remaining">{{!isPremiumPlan ? aiCredits.piPartIdentification  : '*' }}</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-cost">$0.10</div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-auto">
                    <div v-if="hasSavedCards"
                         class="col-with-active-btn">
                      <div class="d-flex" @click="onAutoTopUpToggleClick">
                        <toggle-button
                            v-model="billingAutoTopUp.piPartIdentification"
                            id="rego"
                            class="mb-0 rs-toggle__button"
                            color="#5E79FF"
                            :disabled="!hasSavedCards || isPremiumPlan"
                            :sync="true"
                            :width="30"
                            :labels="false"/>
                        <span
                            class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25" style="font-size: 10px">
                            <template v-if="billingAutoTopUp.piPartIdentification">Active</template>
                            <template v-else>Not Active</template>
                          </span>
                      </div>
                    </div>
                    <div v-else v-b-tooltip.hover="{customClass: 'ps-tooltip', title:'To enable Auto top-up, saved your card next time you Purchase more credit', placement:'bottom'}"
                         class="col-with-active-btn">
                      <div class="d-flex" @click="onAutoTopUpToggleClick">
                        <toggle-button
                            v-model="billingAutoTopUp.piPartIdentification"
                            id="rego"
                            class="mb-0 rs-toggle__button"
                            color="#5E79FF"
                            :disabled="!hasSavedCards || !isPremiumPlan"
                            :sync="true"
                            :width="30"
                            :labels="false"/>
                        <span
                            class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25" style="font-size: 10px">
                            <template v-if="billingAutoTopUp.piPartIdentification">Active</template>
                            <template v-else>Not Active</template>
                          </span>
                      </div>
                    </div>
                  </div>
                  <div class="billing-settings-rs-table-body-item billing-settings-rs-table-body-btn">
                    <button @click="$refs.modalAddCredits.show()" class="btn btn-primary" style="background-color: rgb(94, 121, 255); color: white; width: 90px" :disabled="isPremiumPlan">Buy More</button>
                  </div>
                </div>
              </div>
              <div class="billing-settings-graph">
                <div class="billing-settings-graph-heading d-flex justify-content-between">
                  <div >Overview</div>
                  <div style="font-weight: 500;">Avg Monthly Spend <span style="margin-left: 25px; font-size: 14px; font-weight: 900">${{monthlySpendTotal}}</span></div>
                </div>
                <apexchart type="bar" height="180" :options="chartOptions" :series="series"></apexchart>
              </div>
            </div>
          </div>
          <div v-if="currentTab === 'invoices'" class="rs-scroll">
            <invoices></invoices>
          </div>
        </div>
      </div>
      <modal-wizard class="billing-modal" ref="actionСonfirmation" cancelButtonText="No" finishButtonText="Yes" style="width: 100px"
                    @on-complete="completedChangingSubscriptionConfirmation" @on-close="completedChangingSubscriptionDecline">
        <modal-wizard-tab title="Changing Data Storage Add-on" description="" title-icon-class="ti-align-right">
          <template>
            <div>You are about to change/add a Data storage add-on pack which will be added to your monthly bill.</div>
          </template>
        </modal-wizard-tab>
      </modal-wizard>
      <modal-wizard class="billing-modal" ref="planTypeModal" cancelButtonText="No" finishButtonText="Yes" style="width: 100px"
                    @on-complete="completedPlanTypeModal" @on-close="canceledPlanTypeModal">
        <modal-wizard-tab title="Changing Plan Type" description="" title-icon-class="ti-align-right">
          <template>
            <div>Are you sure?</div>
          </template>
        </modal-wizard-tab>
      </modal-wizard>
      <modal-wizard class="billing-modal" ref="closeAccount" cancelButtonText="Cancel" finishButtonText="Confirm" style="width: 100px"
                    @on-complete="closeAccount">
        <modal-wizard-tab title="Close Account" description="" title-icon-class="ti-align-right">
          <template>
            <div>You are about to close this account, user accounts and services will no longer be available.</div>
          </template>
        </modal-wizard-tab>
      </modal-wizard>
      <modal-add-credits ref="modalAddCredits"></modal-add-credits>
    </div>
  </div>

</template>

<script>
  import NumberFormatter from '../utility/number-formatter';
  import {mapGetters} from "vuex";
  import Multiselect from "vue-multiselect";
  import _ from "lodash";
import Axios from "axios";
import {appConfig} from "../../config";
import Invoices from './billing/invoices';
  import VueApexCharts from "vue-apexcharts";
  import ModalAddCredits from "@/components/utility/modal-add-credits.vue";

  export default {
    name: "Billing",
    components: {
      ModalAddCredits,
      NumberFormatter,
      Multiselect,
      Invoices,
      apexchart: VueApexCharts,
    },
    data() {
      return {
        cost: '0',
        showSettings: true,
        showInvoices: false,
        currentTab: 'Settings',
        currentPlan: null,
        planToRemove: false,
        newPlanType: null,
        chartOptions: {
          chart: {
            id: 'basic-bar',
            toolbar: {
              show: false,
            }
          },
          xaxis: {
            categories: []
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            style: {
              fontSize: '13px',
              fontFamily: 'Nunito Sans',
              fontWeight: 'bold',
            },
          },
        },
        series: [{
          name: 'series-2',
          color: "#5d78fd",
          data: []
        }],
        autoTopUp: {
          daDollarsStandard: false,
          daNtarltarStandard: false,
          viVehicleIdentification: false,
          piPartIdentification: false,
        }
      }
    },
    mounted() {
      if (!_.isEmpty(this.$storage.get("views.advancedSettings.billing.defaultView"))) {
        this.currentTab = this.$storage.get("views.advancedSettings.billing.defaultView");
      } else {
        let path = this.$route.path.split('/');
        let subTab = path[path.length-1];
        if (subTab === 'settings' || subTab === 'invoices') {
          this.currentTab = subTab;
        } else {
          this.currentTab = 'settings';
        }
      }
      this.buildSpendChart();
    },
    methods: {
      buildSpendChart() {
        const maxMonths = 6;
        const now = new Date();
        const categories = [];

        for (let i = maxMonths - 1; i >= 0; i--) {
          const d = new Date(now);
          d.setMonth(now.getMonth() - i);
          categories.push(d.toLocaleString('en', { month: 'short' }));
        }
        const data = new Array(maxMonths).fill(0);
        const spend = (this.monthlySpend || []).slice(-maxMonths);
        const start = maxMonths - spend.length;
        spend.forEach((val, idx) => {
          data[start + idx] = Number(val) || 0;
        });

        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            ...(this.chartOptions.xaxis || {}),
            categories,
          },
          yaxis: {
            labels: {
              formatter: function(val) {
                return '$' + val.toFixed(2);
              }
            }
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return '$' + val.toFixed(2);
              }
            }
          }
        };
        this.series = [{
          name: '',
          color: "#5d78fd",
          data,
        }];
      },
      onAutoTopUpToggleClick() {
        if (!this.hasSavedCards) {
          toastr.error('To enable Auto top-up, saved your card next time you Purchase more credit');
        }
      },
      canceledPlanTypeModal() {
        this.newPlanType = null;
      },
      completedPlanTypeModal() {
        if (!this.newPlanType) {
          return;
        }
        if (this.newPlanType.id == '0') {
          let self = this;
          let plan = _.find(this.value?.billing?.info.activeSubscriptions, (s) => {
            return s.subscription.id == self.computedPlanType.id;
          })
          this.removeSubscription(plan.id, 'Free');
        } else {
          this.addSubscription(this.newPlanType.id, this.newPlanType.name);
        }
        this.$refs.planTypeModal.hide();
      },
      onSelectPlanType(plan) {
        this.newPlanType = plan;
        this.$refs.planTypeModal.show();
      },
    downloadInvoice: function () {
      // let invoice_id = this.$route.params.invoice_id;
      // let q = JSON.stringify(this.invoice.expand);
      // let token = localStorage.getItem('token');
      // var expand_url = '?e=' + encodeURIComponent(q) + '&at=' + token;
      //
      // let url = appConfig.baseAPIURL + '/fe/pdf/invoice/' + invoice_id + expand_url;
      // window.open(url);
      return;
    },
    sctollToTop: function () {
      setTimeout(() => {
        document.getElementsByClassName('modal-dialog')[0].scrollIntoView();
        return true;
      }, 100);
    },
    showPreviewInvoiceModal: function () {
      let invoice_id = this.$route.params.invoice_id;
      var self = this;
      NProgress.start();
      Axios.get(`/fe/invoice/${invoice_id}`)
          .then(response => {
            self.previewInvoice = response.data;

            self.previewInvoice.all_line_items = _.map(self.previewInvoice.all_line_items, lines => {
              lines.line_items.lines = _.mapValues(lines.line_items.lines, items => {
                return _.filter(items, item => item.total != 0);
              });
              return lines;
            });

            let countSubtotal = 0;
            _.forEach(self.previewInvoice.all_line_items, function (lines) {
              _.forEach(lines.line_items.lines, function (item) {
                if (item && item.length > 0) {
                  countSubtotal++;
                }
              });
            });
            self.countSubtotal = countSubtotal;
            NProgress.done();
            self.$refs.previewInvoiceModal.show();

            [].slice.call(Array.from(document.querySelectorAll('[data-class-modal-invoice]'))).map(elem => {
              Object.keys(this.invoiceClasses).forEach(classes => {
                if (document.querySelector('.' + elem.getAttribute('data-class-modal-invoice'))
                    .querySelector('.' + this.invoiceClasses[classes] + '_expand')
                    .getAttribute('data-show-invoice') === 'true') {
                  elem.querySelector('.' + this.invoiceClasses[classes] + '_expand').style.display = 'block';
                  elem.querySelector('.' + this.invoiceClasses[classes]).style.display = 'none';
                } else {
                  elem.querySelector('.' + this.invoiceClasses[classes] + '_expand').style.display = 'none';
                  elem.querySelector('.' + this.invoiceClasses[classes]).style.display = 'block';
                }
              });
            });

          })
          .catch(error => {
            toastr.error("Error occurred while loading invoice info");
            NProgress.done();
          });

    },
      onSelectPlan(plan) {
        if(this.value.billing?.settings.storage_addon_id == plan.id){
          return;
        }
        if(plan.id == 0){
          this.planToRemove = this.currentStorageAddonInfo.activeSubscriptionId;
        } else {
          this.currentPlan = plan;
        }
        this.$refs.actionСonfirmation.show();
      },
      changedLookupStatus() {
        if (this.value.billing?.settings.reg_vin_lookup_always_on && !this.value.billing?.settings.reg_vin_lookup_with_build_and_compliance && !this.value.billing?.settings.reg_vin_lookup) {
          this.value.billing.settings.reg_vin_lookup = true;
        }
      },
      clickCloseAccount() {
        this.$refs.closeAccount.show();
      },
      closeAccount() {
        NProgress.start();
        Axios.post('/fe/settings/vendor-close-account', { action: "DELETE" })
            .then(response => {
              if (response.data && response.data._status) {
                toastr.success("Account has been closed");
              } else {
                toastr.error(response.data.msg);
              }
            })
            .catch(e => console.error(e))
            .finally(() => NProgress.done());
        this.$refs.closeAccount.hide();
      },
    selectedTab(tab) {
      this.currentTab = tab;
      this.$storage.set("views.advancedSettings.billing.defaultView", tab);
      let params = {name: 'billing', params: {tab: tab}};
      this.$router.push(params).catch(() => {
      });
    },
    selectBilling(tab){
        if (tab === 'Settings') {
          this.currentTab = 'Settings'
          this.showSettings = true
          this.showInvoices = false
        } else if (tab === 'Invoices') {
          this.currentTab= 'Invoices'
          this.showSettings = false
          this.showInvoices = true
        }
      },
      completedChangingSubscriptionDecline(){
        this.currentPlan = null;
        this.planToRemove = false;
      },
      completedChangingSubscriptionConfirmation() {
          if(this.planToRemove){
            this.removeSubscription(this.planToRemove);
            this.planToRemove = false;
          } else if(this.currentPlan){
            this.addSubscription(this.currentPlan.id);
            this.planToRemove = null;
          }
          this.$refs.actionСonfirmation.hide();
      },
      addSubscription(subscriptionId, toastrText = false){
        Axios.post('/fe/subscriptions/subscribe', { subscriptionId })
            .then(response => {
              if(response.data && response.data._status){
                this.$emit('reloadVendorSettings', toastrText ? toastrText : null);
                // this.value.billing.info.activeSubscriptions.push(response.data.subscription)
                // if(response.data.subscription.subscription.type == 'plan'){
                //   this.value.billing.settings.plan_id = response.data.subscription.subscription.id;
                // } else if(response.data.subscription.subscription.type == 'storage addon'){
                //   this.value.billing.settings.storage_addon_id = response.data.subscription.subscription.id;
                //   let vm = this;
                //   let item = _.find(vm.value.billing.availablePlans.storages, function (itm) {
                //     return itm.id == vm.value.billing.settings.storage_addon_id;
                //   });
                //   let limit = item.name.split('Gb');
                //   this.value.billing.info.storage.limit = Number(limit[0]) + 10;
                // }
              }
            })
            .catch(e => console.error(e));
      },
      removeSubscription(activeSubscriptionId, toastrText = false){
        Axios.post('/fe/subscriptions/unsubscribe', { activeSubscriptionId })
            .then(response => {
              if(response.data && response.data._status){
                this.$emit('reloadVendorSettings', toastrText ? toastrText : null);
                // this.value.billing.info.activeSubscriptions.push(response.data.subscription)
                // if(response.data.subscription.subscription.type == 'plan'){
                //   this.value.billing.settings.plan_id = response.data.subscription.subscription.id;
                // } else if(response.data.subscription.subscription.type == 'storage addon'){
                //   this.value.billing.settings.storage_addon_id = response.data.subscription.subscription.id;
                //   let vm = this;
                //   let item = _.find(vm.value.billing.availablePlans.storages, function (itm) {
                //     return itm.id == vm.value.billing.settings.storage_addon_id;
                //   });
                //   let limit = item.name.split('Gb');
                //   this.value.billing.info.storage.limit = Number(limit[0]) + 10;
                // }
              }
            })
            .catch(e => console.error(e));
      },
    },
    props: {
      value: {},

    },
    computed: {
      ...mapGetters({
        isShopManagerUser: 'isShopManagerUser',
        isProductionManagerUser: 'isProductionManagerUser',
        vendorInfo: 'vendorInfo',
        isAiCopilotDamageDisabled: 'isAiCopilotDamageDisabled',
        isAiCopilotPartsInfoDisabled: 'isAiCopilotPartsInfoDisabled',
        isAiCopilotVehicleDisabled: 'isAiCopilotVehicleDisabled',
        isStatusActive: 'isStatusActive',
        aiCredits: 'aiCredits/aiCredits',
        hasCredits: 'aiCredits/hasCredits',
        getSavedCards: 'getSavedCards',
        isPremiumPlan:'isPremiumPlan',
        isAiCopilotFullyInActive: 'isAiCopilotFullyInActive',
      }),
      monthlySpend(){
        const avg6 = this.value?.billing?.credits?.avg6 || [];
        if (!Array.isArray(avg6)) {
          return Object.values(avg6);
        }
        if (avg6.length === 0) {
          return [];
        }
        if (Array.isArray(avg6[0])) {
          return avg6[0];
        }
        return Object.values(Object.assign({}, ...avg6));
      },
      planTypeOptions() {
        return this.value?.billing?.availablePlans?.plans || [];
      },
      storageAddonOptions() {
        return this.value?.billing?.availablePlans?.storages || [];
      },
      hasBillingCredits() {
        return !!(this.value?.billing?.credits);
      },
      billingAutoTopUp() {
        return this.value?.billing?.credits?.autoTopUp || this.autoTopUp;
      },
      // isPremiumPlan(){
      //   return this.value?.billing?.info?.activeSubscriptions[0]?.subscription?.name === 'Premium'
      // },
      monthlySpendTotal(){
        const total = (this.monthlySpend || []).reduce((sum, val) => {
          const num = Number(val);
          return sum + (Number.isFinite(num) ? num : 0);
        }, 0);
        return total.toFixed(2);
      },
      hasSavedCards() {
        const cards = this.getSavedCards;
        return Array.isArray(cards) && cards.length > 0;
      },
      computedPlanType: {
        get: function () {
          let vm = this;
          try {
            let item = {
              id: 0,
              name: 'Free',
              price: 0,
              type: 'plan',
            };
            _.forEach(this.value?.billing?.availablePlans?.plans, function (itm) {
              let activeSub = _.find(vm.value?.billing?.info.activeSubscriptions, (s) => {
                return s.subscription.id == itm.id && s.subscription.type == 'plan'
              })
              if (activeSub) {
                item = itm
              }
            });
            return item;
          } catch (e) {
            console.log(e)
            return {
              id: 0,
              name: 'Free',
              price: 0,
              type: 'plan',
            };
          }
        },
        set: function (item) {

        },
      },
      computedProgressTextAlign() {
        let limit = 10;

        if (+this.value?.billing?.info.storage.limit !== 0) {
          limit = this.value?.billing?.info.storage.limit;
        }
        let percents =  100 / Number(limit) * parseFloat(this.computedStorageConsumedLimit);
        if (percents <= 50) {
          return 'progress-text-right'
        } else {
          return 'progress-text-left'
        }
      },
      computedPlan: {
        get: function () {
          let vm = this;
          try {
            let item = _.find(vm.value?.billing?.availablePlans?.storages, function (itm) {
              return itm.id == vm.currentStorageAddonInfo.id;
            });
            return item;
          } catch (e) {
            return {};
          }
        },
        set: function (item) {

        },
      },
      computedLimit: {
        get() {
          let result = this.value?.billing?.info.storage.limit + 'GB';
          return result
        },
        set (value) {
          return value
        }
      },
      computedCost: {
        get() {
          let result = 0;
          _.forEach(this.value?.billing?.info.activeSubscriptions, (s) => {
            result += parseFloat(s.subscription.price)
          })
          return result
        },
        set(value) {
          return value
        }
      },
      computedColorForProgressBar() {
        if (this.isOverLimit) {
          return  'progress-bar-of-gb-error';
        }
        return 'progress-bar-of-gb-default';
      },
      isOverLimit() {
        return this.value?.billing?.info.storage.limit != 0 && this.value?.billing?.info.storage.consumed >= this.value?.billing?.info.storage.limit;
      },
      computedStorageConsumedLimit() {
        if (this.isOverLimit) {
          return this.value?.billing?.info.storage.limit
        }
        return this.value?.billing?.info.storage.consumed;
      },
      disabled(){
        if ((this.isShopManagerUser || this.isProductionManagerUser) && this.isStatusActive) {
          return false
        }
        return true
      },
      currentStorageAddonInfo(){
        let data = {
          id: 0,
          activeSubscriptionId: 0,
          price: 0,
          per: '0Gb',
          billed: 'Monthly'
        };

        const activeSubscriptions = this.value?.billing?.info?.activeSubscriptions || [];

        let addon = null;
        for (let a of activeSubscriptions) {
          if(a.subscription && a.subscription.type == 'storage addon'){
            addon = a;
            break;
          }
        }
        if(addon){
          data.id = addon.subscription.id;
          data.activeSubscriptionId = addon.id;
          data.price = addon.subscription.price;
          data.per = Math.round(addon.subscription.features.storage.maxAmount.value / 1073741824) + 'Gb';
          data.billed = 'every ' + addon.subscription.periodLength + ' ' + addon.subscription.periodVariant + '(s)';
        }
        return data;
      },
    },
    watch: {
      monthlySpend: {
        handler() {
          this.buildSpendChart();
        },
        immediate: true
      }
    }

  }
</script>

<style>
  .fade.show {
    opacity: 1 !important;
  }
  .billing-modal .modal-dialog {
    width: 480px;
  }
</style>

<style scoped>
.billing-settings-rs-table-header{
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
}
.billing-settings-rs-table-header-item{
  padding: 0.75rem;
}
.billing-settings-rs-table-body{
  border: 1px solid rgba(27, 30, 56, 0.15);
  border-top: 0;
}
.billing-settings-rs-table-body-item{
  padding: 0.75rem;
  font-weight: 700;
}
.billing-settings-rs-table-header-name,
.billing-settings-rs-table-body-name{
  min-width: 110px;
  flex-grow: 1;
}
.billing-settings-rs-table-header-remaining,
.billing-settings-rs-table-body-remaining{
  min-width: 85px;
  max-width: 85px;
}
.billing-settings-rs-table-body-remaining{
  text-align: center;
  align-self: center;
}
.billing-settings-rs-table-header-cost,
.billing-settings-rs-table-body-cost{
  min-width: 60px;
  max-width: 60px;
}
.billing-settings-rs-table-body-cost{
  align-self: center;
}
.billing-settings-rs-table-body-cost{
  padding-left: 0;
}
.billing-settings-rs-table-header-auto,
.billing-settings-rs-table-body-auto{
  min-width: 85px;
  max-width: 85px;
}
.billing-settings-rs-table-body-auto{
  padding: 0;
  align-self: center;
  position: relative;
  bottom: 5px;
}
.billing-settings-rs-table-header-btn,
.billing-settings-rs-table-body-btn{
  min-width: 100px;
  max-width: 100px;
  padding: 10px 5px;
}
.billing-settings-rs-table-body-btn{
  align-self: center;
}
.billing-settings-graph{
  border: 1px solid rgba(27, 30, 56, 0.15);
  border-radius: 5px;
  padding: 10px;
  margin-top: 15px;
}
.billing-settings-graph-heading{
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
}
.credit-card-block {
  border-radius: 10px;
  border: 1px solid rgba(27, 30, 56, 0.25) !important;
}
.credit-card-block-last {
  padding: 15px;
  width: 320px;
}
.credit-card-block-first {
  width: 350px;
  padding: 15px 15px 15px 0px;
}
.color-blue {
  color: #5E79FF;
}
.border-bottom-without-plus {
  border-bottom: 1px solid rgba(27, 30, 56, 0.25) !important;
}
  .not-active {
    background-color: #fff !important;
    color: #fff !important;
  }
  .btn{
    color: #1C1F39;
    background-color: rgba(27, 30, 56, 0.12);
    width: 75px;
    font-weight: bold;
  }
  .btn-group {
    border: 1px solid rgba(27, 30, 56, 0.12);
    border-radius: 3px;
    padding: 2px 5px;
    width: 162px;
  }
  .billing .nav-item:hover {
    cursor: pointer;
  }
  .billing .description-text {
    color: rgba(0, 0, 0, 0.5);
  }
  .billing .text-active {
    min-width: 60px;
  }
  .progress-of-gb {
    width: 162px;
    border: 2px solid rgba(27, 30, 56, 0.12);
    border-radius: 3px;
    position: relative;
  }
  .progress-bar-of-gb-default {
    background-color: #5E79FF !important;
  }

  .progress-bar-of-gb-error {
    background-color: red !important;
  }

  .progress-bar-of-gb {
    height: 28px;
    text-align: right;
    border-radius: 3px;
  }
  .progress-text {
    font-size: 12px;
    line-height: 28px;
    margin-right: 10px;
    white-space: nowrap;
    font-weight: bold;
  }
  .progress-text-left {
    float: left;
    padding-left: 7px;
  }

  .progress-text-right {
    position: absolute;
    right: -6px;
    z-index: 100;
  }

  .progress-text-black{
    color: #000;
  }
  @media (min-width: 576px) {
    .billing .col-sm-9 {
      width: 25% !important
    }
    .billing .col-with-active-btn {
      width: 25% !important
    }
    .billing .description {
      width: 39%;
    }
    .col-with-active-btn {
      padding-top: 16px;
    }
    .col-sm-9 {
      width: 50%;
    }

  }
  @media (min-width: 992px) {
    .billing .description {
      width: 67%;
    }
    .billing .left-col {
      width: 50%;
    }
    .col-with-active-btn {
      padding-top: 16px;
    }
  }
  @media (max-width: 1680px){
    .settings-tab-width{
      width: 30%;
    }
    .settings-tab-width-credits{
      width: 40%;
    }
  }
@media (max-width: 1680px){
  .settings-tab-width{
    width: 50%;
  }
  .settings-tab-width-credits{
    width: 70%;
  }
}
  @media (max-width: 992px){
    .settings-tab-width,
    .settings-tab-width-credits{
      width: 100%;
    }
  }

  .w-162 {
    width: 162px;
  }

  .billing-disabled {
    color: #8c8c8c;
  }
</style>
